// extracted by mini-css-extract-plugin
module.exports = {"buttonRow":"toolbar-design-system_buttonRow__hCGgd","stack":"toolbar-design-system_stack__070zW"};